import script from "./AdsCampaignCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AdsCampaignCard.vue?vue&type=script&setup=true&lang=js"

import "./AdsCampaignCard.vue?vue&type=style&index=0&id=4ac65526&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ac65526"]])

export default __exports__